export const environment = {
  production: true,
  version: 'f4530867c9',
  site_version: 'SITE_VERSION'
};
